import { Card, Col, Table } from "reactstrap";
import AddProjectsAndUploadTableBody from "./AddProjectsAndUploadTableBody";
import CommonCardHeader from "../../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { AddProjectsAndUploadTitle } from "../../../../../Constants/Constants";

const AddProjectsAndUpload = () => {
  return (
    <Col md="12">
      <Card>
        <CommonCardHeader headClass="pb-4" title={AddProjectsAndUploadTitle} />
        <div className="table-responsive add-project custom-scrollbar">
          <Table className="card-table table-vcenter text-nowrap">
            <thead className="bg-light-primary">
              <tr>
                <th>ProjectName</th>
                <th>Date</th>
                <th>Status</th>
                <th>Price</th>
                <th />
              </tr>
            </thead>
            <AddProjectsAndUploadTableBody />
          </Table>
        </div>
      </Card>
    </Col>
  );
};

export default AddProjectsAndUpload;
